import { render, staticRenderFns } from "./VolunteerNetMatchCustomer.vue?vue&type=template&id=e8e71048"
import script from "./VolunteerNetMatchCustomer.vue?vue&type=script&lang=ts"
export * from "./VolunteerNetMatchCustomer.vue?vue&type=script&lang=ts"
import style0 from "./VolunteerNetMatchCustomer.vue?vue&type=style&index=0&id=e8e71048&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports